/**
 * Basic Configuration (.env) reader that can fetch keys. The config is defined
 * as a global at build time by Vue CLI.
 * @link https://cli.vuejs.org/guide/mode-and-env.html#environment-variables
 */
export class ConfigReader {
    /**
     * Defines all variables used in the application and their types.
     * @type {{}}
     */
    static SettingKeys = {
        NODE_ENV: 'string',
        BASE_URL: 'string',
        VUE_APP_API_SPEC_URL: 'string',
        VUE_APP_ENABLE_FULLSTORY: 'string',
        VUE_APP_GTM_ID: 'string',
        VUE_APP_INTERCOM_ID: 'string',
        VUE_APP_PREFETCH_API_DEFINITIONS: 'string',
        VUE_APP_API_REQUEST_TIMEOUT_MS: 'string',
        VUE_APP_API_URL: 'string',
        VUE_APP_API_VERSION: 'string',
        VUE_APP_APPLICATION_TITLE: 'string',
        VUE_APP_CHECK_SESSION_INTERVAL_MS: 'string',
        VUE_APP_CHECKOUT_URL: 'string',
        VUE_APP_DEBUG: 'boolean',
        VUE_APP_MODE: 'string',
        VUE_APP_PHP_DEBUG: 'boolean',
        VUE_APP_RELEASE_VERSION: 'string',
        VUE_APP_REMEMBER_DURATION_MS: 'string',
        VUE_APP_SESSION_DURATION_MS: 'number',
        VUE_APP_SWITCH_MODE_URL: 'string',
        VUE_APP_USE_WEB_STORAGE_FOR_JWT: 'boolean',
        // from Amplify Console
        VUE_APP_AMP_APP_ID: 'string',
        VUE_APP_AMP_JOB_ID: 'string',
    };

    static Affirmations = ['true', 'True', 'on', 'On', 'yes', 'Yes'];

    static Coerce(type, value) {
        if (value === null) {
            return null;
        }
        switch (type) {
            case 'string':
                return `${value}`;
            case 'boolean':
                return (value && ConfigReader.Affirmations.includes(value)) === true;
            case 'number':
                return value * 1;
            case 'object':
                return JSON.parse(value);
            default:
                throw new Error('Invalid type');
        }
    }

    constructor(settings, keys) {
        Object.entries(keys).forEach(([name, type]) => {
            Object.defineProperty(this, name, {
                enumerable: true,
                get() {
                    return name in settings
                        ? ConfigReader.Coerce(type, settings[name])
                        : null;
                },
            });
        });
    }
}

/**
 * Singleton decorator for process.env in order to coerce values,
 * since process.env forces all values to be strings.
 */
export default new ConfigReader(
    process.env,
    ConfigReader.SettingKeys,
);
